import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnboardingCompany = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 53,
	viewBox: "0 0 48 53",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M44.7122 17.523C47.5706 16.5394 49.001 13.2367 47.208 10.776C42.4451 4.23945 34.7881 0 26.1537 0C11.7094 0 0 11.8645 0 26.5C0 41.1355 11.7094 53 26.1537 53C34.4723 53 41.8837 49.065 46.6739 42.9318C48.7662 40.2529 47.1813 36.5455 43.9885 35.4478C41.7028 34.662 39.1509 35.4072 37.3989 37.0895C36.7377 37.7244 36.0494 38.3658 35.3817 39.0011C27.0144 46.9625 8.48706 46.0404 8.48706 46.0404C8.48706 46.0404 12.922 41.0363 14.4986 37.2656C11.6555 34.3533 9.90183 30.3601 9.90183 25.9547C9.90183 17.0409 17.0817 9.81481 25.9385 9.81481C30.689 9.81481 34.957 11.8937 37.8935 15.1968C39.6273 17.1471 42.2592 18.3671 44.7122 17.523Z",
		fill: "#00897B"
	})]
});
const ForwardRef = forwardRef(SvgOnboardingCompany);
export { ForwardRef as ReactComponent };
